import React, { useState } from 'react';

// state: accessToken for now
const SignInContext = React.createContext([{}, () => {}]);

const SignInProvider = (props) => {
  const [state, setState] = useState({});
  return <SignInContext.Provider value={[state, setState]}>{props.children}</SignInContext.Provider>;
};

const SignInConsumer = SignInContext.Consumer;

export { SignInProvider, SignInContext, SignInConsumer };
